import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../utils/mockData';

const Location = () => {
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyInfo.address)}`;

  return (
    <section id="localizacao" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
              <p className="text-[#1e3a8a] text-sm font-semibold">LOCALIZAÇÃO</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Onde nos encontrar
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Venha nos visitar! Estamos localizados em um ponto de fácil acesso na Parquelândia, Fortaleza.
            </p>

            {/* Address Card */}
            <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6 hover:shadow-lg transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Endereço</h3>
                  <p className="text-gray-700 leading-relaxed">
                    {companyInfo.address}
                  </p>
                </div>
              </div>
            </div>

            {/* Hours Card */}
            <div className="bg-gradient-to-br from-[#1e3a8a]/5 to-[#3b82f6]/5 border border-[#1e3a8a]/20 rounded-xl p-6 mb-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl">🕐</span>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Horário de Funcionamento</h3>
                  <p className="text-gray-700">
                    {companyInfo.hours}
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <Button 
              onClick={() => window.open(googleMapsUrl, '_blank')}
              size="lg"
              className="bg-[#1e3a8a] hover:bg-[#1e3a8a]/90 text-white font-semibold px-8 w-full md:w-auto shadow-lg hover:shadow-xl transition-all"
            >
              <Navigation className="w-5 h-5 mr-2" />
              Ver Rota no Google Maps
            </Button>
          </div>

          {/* Right Content - Map */}
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl border-4 border-white">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3107726831844!2d-38.56877!3d-3.74417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c7491c0e0c0c0c%3A0x0!2sRua%20Cruz%20Saldanha%2C%2041%20-%20Parquel%C3%A2ndia%2C%20Fortaleza%20-%20CE!5e0!3m2!1spt-BR!2sbr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização da Gráfica Rápida Infortech"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
